import WelcomeScreen from "./Welcome/welcomeScreen";
import DepartmentPrice from "./departmentPrice/departmentPrice";
import Department from "./department/department";
import PatientProfile from "./patientProfle/patientProfile";
import PageNotFound from "./pageNotFound/pageNotFound";
import DriverProfile from "./driverProfile/DriverProfile";
import Ambulance from "./ambulance/Ambulance";
import NurseRequest from "./nursingCare/NurseRequest";
import ServiceDetails from "./nursingCare/ServiceDetials";
import Article from "./healthArticles/Article";
import NationalID from "./nationalId/NationalID";
import TermsCondition from "./terms-condition/tnc";

const Pages = {
  WelcomeScreen,
  DepartmentPrice,
  Department,
  PatientProfile,
  PageNotFound,
  DriverProfile,
  Ambulance,
  ServiceDetails,
  NurseRequest,
  Article,
  NationalID,
  TermsCondition,
};

export default Pages;
